import { formatPhoneNumber } from '@App/helpers/another-phone-formatter'
import React, { useContext } from 'react'
import { formatCityStateCode, formatStreetAddress } from '@App/helpers/format-address'
import { formatName } from '@App/helpers/format-name'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { getCountryTitle } from '@App/helpers/get-country-title'
import { RightsholderContact } from '@Entities/rightsholder/rightsholder-contact'

export interface ContactDetailsBlockProps {
    contact: RightsholderContact
}
const ContactDetailsBlock = (props: ContactDetailsBlockProps) => {
    const { libStore } = useContext<RootStore>(StoresContext)
    const { contact } = props

    const name = formatName(contact.firstName, contact.lastName)

    const fullStreetAddress = contact.address ? formatStreetAddress(contact.address) : ''
    const cityStateCode = contact.address ? formatCityStateCode(contact.address) : ''
    const fullPhoneNumber = contact.phoneNumber ? formatPhoneNumber(contact.phoneNumber) : ''
    const countryTitle = getCountryTitle(
        libStore.countries,
        contact.address?.countryId ? Number(contact.address.countryId) : null
    )

    return (
        <div>
            <p>{name}</p>
            <p>{fullStreetAddress}</p>
            <p>{cityStateCode}</p>
            <p>{countryTitle}</p>
            <p>{fullPhoneNumber}</p>
            <p>{contact.email}</p>
        </div>
    )
}

export default ContactDetailsBlock
